export * from './media-queries-sync.service';
